import { Link } from "react-router-dom";

export const Footer = ({ t }) => (
  <footer data-testid="site-footer" className="bg-[#1C3829] text-[#F7F5F0]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 border-t border-[#F7F5F0]/10 flex flex-col md:flex-row justify-between gap-4 text-xs uppercase tracking-[0.2em] text-[#F7F5F0]/40">
      <span data-testid="footer-brand">{t.footer}</span>
      <div className="flex gap-6">
        <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[#C29B62] transition-colors">Privacy Policy</Link>
        <Link to="/cookie-policy" data-testid="footer-cookie-link" className="hover:text-[#C29B62] transition-colors">Cookie Policy</Link>
      </div>
      <span>Villa Navagero Erizzo · Est. 1420</span>
    </div>
  </footer>
);
